import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { map, of, take } from 'rxjs';
import { TherapyJobStore } from '../store/job.store';

@Injectable({ providedIn: 'root' })
export class DetailPageGuard implements CanActivate {
  private readonly jobStore = inject(TherapyJobStore);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const urlTree = this.router.parseUrl(state.url);

    // urlTree id used when the detail page is load
    // route param id used when navigating from the angular app the detail page
    const idParam = urlTree.queryParams['id'] || route.paramMap.get('id');

    if (!idParam) {
      this.router.navigate(['/home'], {
        queryParamsHandling: 'merge'
      });

      return of(false);
    }

    if (this.jobStore.entityMap()?.[idParam]) {
      return of(true);
    }

    return this.jobStore.load(false).pipe(
      take(1),
      map(() => {
        const exists = !!this.jobStore.entityMap()[idParam];
        if (!exists) {
          this.router.navigate(['/home'], {
            queryParamsHandling: 'merge'
          });
        }
        return exists;
      })
    );
  }
}
